/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_H1_BeforeInputs */

const es_ab_h1_before = /** @type {(inputs: Ab_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a la `)
};

const gl_ab_h1_before = /** @type {(inputs: Ab_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete á `)
};

const en_ab_h1_before = /** @type {(inputs: Ab_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the `)
};

/**
* | output |
* | --- |
* | "Join the" |
*
* @param {Ab_H1_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_h1_before = /** @type {((inputs?: Ab_H1_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_H1_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_h1_before(inputs)
	if (locale === "en") return en_ab_h1_before(inputs)
	return es_ab_h1_before(inputs)
});